"use client";

import React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  author: "Marcus von Berg",
  quote: "The AI-enhanced photos transformed our booking rate overnight. A true revolution for luxury hospitality.",
  position: "GENERAL MANAGER, VIENNA"
}, {
  author: "Elena Rossi",
  quote: "Finally, a service that understands the soul of a boutique hotel. The visual clarity is simply unmatched.",
  position: "OWNER, TUSCANY RETREAT"
}, {
  author: "Julian Schmidt",
  quote: "Better Hotel Photos doesn't just edit photos; they curate an atmosphere that guests feel before they even arrive.",
  position: "DIRECTOR, BERLIN LOFTS"
}, {
  author: "Sophie Laurent",
  quote: "Our ADR increased by 15% after updating our gallery with these stunning, high-conversion visuals.",
  position: "MARKETING HEAD, PARIS"
}];
export default function VoicesOfExcellence() {
  return <section data-section-id="231009" id="voices-of-excellence" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 z-0 opacity-[0.05] pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684351/img/linen_texture_overlay.png)] bg-fixed bg-center bg-no-repeat bg-cover mix-blend-multiply"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="text-3xl md:text-5xl font-default font-light mb-6 tracking-widest uppercase">
            Voices of Excellence
          </h2>
          <div className="w-12 h-0.5 bg-secondary mx-auto rounded-md"></div>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full max-w-6xl mx-auto">
          <CarouselContent className="-ml-4 md:-ml-6">
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                <div className="bg-card/50 backdrop-blur-sm rounded-md p-8 md:p-10 h-full flex flex-col justify-between border border-border/40 shadow-sm transition-transform duration-500 hover:-translate-y-1">
                  <div>
                    <div className="flex gap-1.5 mb-8 text-secondary">
                      {[...Array(5)].map((_, starIndex) => <Star key={starIndex} data-index={starIndex} className="w-3 h-3 fill-current" />)}
                    </div>
                    <p className="font-serif italic text-xl md:text-2xl leading-relaxed text-foreground/90 mb-10">
                      "{testimonial.quote}"
                    </p>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-md bg-secondary/10 flex items-center justify-center text-secondary font-serif font-medium text-lg border border-secondary/20">
                      {testimonial.author.charAt(0)}
                    </div>
                    <div>
                      <p className="font-default font-semibold text-foreground tracking-wide text-sm uppercase">
                        {testimonial.author}
                      </p>
                      <p className="font-default text-[10px] text-secondary font-bold tracking-widest uppercase mt-0.5">
                        {testimonial.position}
                      </p>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="flex items-center justify-center gap-4 mt-12 md:mt-16">
            <CarouselPrevious className="relative inset-auto translate-x-0 translate-y-0 h-12 w-12 rounded-md border-secondary/30 bg-background/80 backdrop-blur-md text-secondary hover:bg-secondary hover:text-secondary-foreground transition-all duration-300" />
            <CarouselNext className="relative inset-auto translate-x-0 translate-y-0 h-12 w-12 rounded-md border-secondary/30 bg-background/80 backdrop-blur-md text-secondary hover:bg-secondary hover:text-secondary-foreground transition-all duration-300" />
          </div>
        </Carousel>
      </div>
    </section>;
}